import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	MULTI_PSK_FILTER_EVENT,
	MULTI_PSK_FOCUS_EVENT,
	MULTI_PSK_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.multi_psks']);

/**
 * Open the Multi PSK accordion on the Templates page.
 * @return {Promise<void>} completion acknowledgement
 */
export function openMultiPskSection() {
	return openResourceSection(
		MULTI_PSK_SECTION_EVENT,
		'profile.multi_psks',
		SECTIONS,
	);
}

/**
 * Filter the Multi PSK table to a search term.
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyMultiPskFilter(query) {
	return dispatchAcknowledgedEvent(MULTI_PSK_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'multi_psk',
	});
}

/**
 * Point at one Multi PSK row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusMultiPsk(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_multi_psk_focus'));
	return dispatchAcknowledgedEvent(MULTI_PSK_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'multi_psk',
	});
}
